/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Integrations_Toggle_AriaInputs */



/**
* | output |
* | --- |
* | "Toggle {name}" |
*
* @param {Integrations_Toggle_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_toggle_aria = /** @type {((inputs: Integrations_Toggle_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Toggle_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} umschalten`)
	return /** @type {LocalizedString} */ (`Toggle ${i?.name}`)
});